import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './loginPage.module.css';
import BackgroundImage from '../BackgroundImage';
import LoginSidebar from '../LoginSidebar';

const LoginPage = ({ toStep1 }) => (
  <Fragment>
    <login-sidebar class={`${s.login_sidebar} login-sidebar`}>
      <LoginSidebar toStep1={toStep1} />
    </login-sidebar>
    <background-image class={s.background_image}>
      <BackgroundImage />
    </background-image>
  </Fragment>
);

LoginPage.propTypes = {
  toStep1: PropTypes.func.isRequired,
};

export default LoginPage;
